import { PropsWithChildren, useMemo, useState } from "react";
import { AppBarFiltersContainerContext } from "./AppBarFiltersContainerContext";

interface Props {}

export const AppBarFiltersContainerContextProvider = ({
  children,
}: PropsWithChildren<Props>) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const contextValue = useMemo(() => ({ container, setContainer }), [
    container,
  ]);
  return (
    <AppBarFiltersContainerContext.Provider value={contextValue}>
      {children}
    </AppBarFiltersContainerContext.Provider>
  );
};
